/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';

import LoginForm from './LoginForm';
import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo from './img/logo.png';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'toolbox-oauth-test-body';
    document.title = 'Toolbox Test';
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="toolbox-oauth-test">
        <main className="container">
          <div className="container-img">
            <img src={logo} alt="logo" id="logo" />
          </div>
          {
            this._validateParams()
              ? <LoginForm
                api={this.api}
                location={this.props.location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </main>
      </div>
    );
  }
}

export default WithLocalize(Login);
